module.exports = __webpack_public_path__ + "img/oneonone.aab5b6b.jpg";